import
{
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    FormControl,
    IconButton,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
    TextField,
    Toolbar,
    Typography
} from "@mui/material";
import { Check, Close } from "@mui/icons-material";
import React, { useState } from "react";
import { selectConstants } from "../../redux/selectors/firebase";
import { Constants } from "../graph/StateTags";
import { connect } from "react-redux";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
    toolbar: {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
    },
    title: {
        marginLeft: theme.spacing(2)
    },
    formControl: {
        width: "100%",
        padding: theme.spacing(1)
    },
    label: {
        left: "unset",
        top: "unset",
        backgroundColor: "white"
    }
}));


interface Props
{
    open: boolean
    close: () => void
    constants: Constants
    createSheet: (name: string, group?: string) => void
}

function AddSheetDialog({ open, constants, close, createSheet }: Props)
{
    const classes = useStyles();
    const [name, setName] = useState("");
    const [type, setType] = useState<string>("none");

    const handleChangeName = (event: React.ChangeEvent<HTMLInputElement>) =>
    {
        setName(event.target.value);
    }

    const handleChangeType = (event: SelectChangeEvent) =>
    {
        setType(event.target.value as string);
    }

    const handleClickComplete = () =>
    {
        if (type !== null && name.length > 0)
        {
            createSheet(name, type);
            reset();
            close();
        }
    }

    const handleClickCancel = () =>
    {
        reset();
        close();
    }

    const reset = () =>
    {
        setName("");
        setType("none");
    }

    const handleClose = () =>
    {
        reset();
        close();
    }

    const selectConstants = Object.entries(constants ?? {}).map(([id, constant]) => ({ id, name: constant.name })).concat({ id: "none", name: "None" });

    return <Dialog open={open} onClose={handleClose}>
        <Toolbar className={classes.toolbar} variant="dense">
            <Box flexGrow={1}>
                <Typography className={classes.title} variant="h6">Add Sheet</Typography>
            </Box>
        </Toolbar>
        <DialogContent>
            <FormControl className={classes.formControl}>
                <TextField fullWidth value={name} onChange={handleChangeName} label={"Name"} />
            </FormControl>
            <FormControl fullWidth className={classes.formControl}>
                <InputLabel className={classes.label}>Group</InputLabel>
                <Select fullWidth value={type} onChange={handleChangeType} placeholder="Type">
                    {selectConstants.map(({ id, name }) => <MenuItem key={id} value={id}>{name}</MenuItem>)}
                </Select>
            </FormControl>
            <DialogActions>
                <IconButton onClick={handleClickComplete} disabled={type.length === 0 || name.length === 0}>
                    <Check />
                </IconButton>
                <IconButton onClick={handleClickCancel}>
                    <Close />
                </IconButton>
            </DialogActions>
        </DialogContent>
    </Dialog >
}

const mapStateToProps = (store: never) => ({
    constants: selectConstants(store)
});
export default connect(mapStateToProps, {
})(AddSheetDialog);